import { useState, useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { getPremium, usePremiumSelector } from "../../redux/reducers/PremiumReducer/PremiumReducer";
import { useConfigurationSelector } from "../../redux/reducers/ConfigurationReducer/ConfigurationReducer";
import { createAccessRequest, getAppPlansUrl, getProductUrl, getProductUrlByWS } from "../../apis/AdminCenter/adminCenterApi";
import { useMsTeamsSelector } from "../../redux/reducers/MicrosoftTeamsReducer/MicrosoftTeamsReducer";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/reducers/ModalReducer/ModalReducer";
import { translations } from "../../translations";
import { useTranslate } from "../../hook/useTranslate";
import { useAppConfigurationSelector } from "../../redux/reducers/AppConfigurationReducer/AppConfigurationReducer";
import { appSourceBaseUrl } from "../dialogs/Upgrade/UpgradeDialog";
import { configIframe } from "../../const/configIframe";
import { IframeManager } from "../../utils/IframeManager";
import { prioritizeInAppPurchase } from "../../utils/prioritizeInAppPurchase";
export const useLogic = (props) => {
    const { adminCenterData } = usePremiumSelector("adminCenterData");
    const { locale, userName, userId, tenantId, isOnMobile, userMail } = useMsTeamsSelector("locale", "userName", "userId", "tenantId", "isOnMobile", "userMail");
    const { data: config } = useConfigurationSelector("data");
    const { from } = useAppConfigurationSelector("from");
    const [licencePlanId, setLicencePlanId] = useState("");
    const [requestAccessFailed, setRequestAccessFailed] = useState(false);
    const dispatch = useDispatch();
    const t = useTranslate(translations);
    const [user, setUser] = useState({});
    const [state, setState] = useState({
        loaded: false,
        isPaymentOpen: false,
        showPremiumActivatedContent: false,
        isLicencesAvailable: false,
        showRequestAccessDialog: false,
        requestAccessMessage: "",
        sendingAccessRequest: false,
        isPendingAccessRequest: false,
        isRequestSent: false,
        appName: "",
        isUserAdmin: false,
        isUserSubscriptionOwner: false,
        forceUpgradePremium: false,
        upgradePremiumMessage: t("UnlockPremiumFeatures"),
        appSourceOpened: false,
        isAppPurchaseOpened: false
    });
    const getDefaultRequestMessage = async (productName) => {
        return t("DefaultRequestMessage", {
            userName: userName,
            appTitle: productName,
        });
    };
    /**
     * Update config
     */
    const updateConfig = (config) => {
        setState((prevState) => {
            const newState = { ...prevState };
            if (config.forceUpgradePremium)
                newState.forceUpgradePremium = config.forceUpgradePremium;
            if (config.upgradePremiumMessage)
                newState.upgradePremiumMessage = config.upgradePremiumMessage;
            return newState;
        });
    };
    useEffect(() => {
        if (!adminCenterData)
            return;
        const init = async () => {
            await microsoftTeams.app.initialize();
            const context = await microsoftTeams.app.getContext();
            setLicencePlanId(adminCenterData.subscriptionLicenceId);
            const defaultRequestMessage = await getDefaultRequestMessage(adminCenterData.productName);
            setUser({
                AadId: context.user.id,
                Upn: context.user.userPrincipalName,
                DisplayName: context.user.displayName,
                Email: context.user.userPrincipalName,
                TenantId: context.user.tenant.id,
            });
            setState((prev) => ({
                ...prev,
                isPendingAccessRequest: adminCenterData.isAccessRequestPending,
                isLicencesAvailable: adminCenterData.isTenantLicenceAvailable,
                requestAccessMessage: defaultRequestMessage,
                isUserAdmin: adminCenterData.isUserAdmin,
                isUserSubscriptionOwner: adminCenterData.subscriptionOwner === userId,
                loaded: true,
            }));
            //props.onRef({ updateConfig: updateConfig });
        };
        init();
    }, [adminCenterData]);
    /**
     * Show payment page
     */
    const showPaymentPage = () => {
        setState((prev) => ({ ...prev, isPaymentOpen: true }));
        !!props.appInsight && props.appInsight?.trackEvent({
            name: "premium_pricing_open",
        });
        if (config.appSourceOfferId != undefined && config.appSourceOfferId.trim() != "" && prioritizeInAppPurchase(from)) {
            microsoftTeams.monetization.openPurchaseExperience();
            setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: false, isClosable: true, appSourceOpened: false, isAppPurchaseOpened: true }));
        }
        else if (config.appSourceOfferId != undefined && config.appSourceOfferId.trim() != "") {
            setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: false, isClosable: false, appSourceOpened: true }));
            setTimeout(() => {
                setState((prev) => ({ ...prev, isClosable: true }));
                window.open(appSourceBaseUrl + locale + "/product/web-apps/" + config.appSourceOfferId, "_blank");
            }, 4000);
        }
        else {
            const dataFunction = (data) => {
                if (data.err && !data.result) {
                    setLicencePlanId("");
                    setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: false }));
                    !!props.appInsight && props.appInsight?.trackEvent({
                        name: configIframe.PremiumPricing.trackingIds.cancel,
                    });
                }
                else {
                    setLicencePlanId(data.result);
                    setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: true }));
                    !!props.appInsight && props.appInsight?.trackEvent({ name: configIframe.PremiumPricing.trackingIds.validate });
                }
            };
            IframeManager(configIframe.PremiumPricing, isOnMobile, props.appInsight, from, getAppPlansUrl(user, props.appId, userMail, config.adminCenterBaseUrl), getAppPlansUrl(user, props.appId, userMail, undefined, config.adminCenterBaseUrl), dataFunction);
        }
    };
    /**
     * Assign licences
     */
    const assignLicences = () => {
        const dataFunction = (data) => {
            if (data.err && !data.result) {
                !!props.appInsight && props.appInsight?.trackEvent({
                    name: configIframe.PremiumAssign.trackingIds.cancel,
                });
            }
            else {
                setState((prev) => ({ ...prev, isPaymentOpen: false, showPremiumActivatedContent: true }));
                !!props.appInsight && props.appInsight?.trackEvent({ name: configIframe.PremiumAssign.trackingIds.validate });
                dispatch(openModal(undefined));
                dispatch(getPremium({ tid: tenantId, userId }));
            }
        };
        IframeManager(configIframe.PremiumAssign, isOnMobile, props.appInsight, from, getProductUrlByWS(user, licencePlanId, userMail, config.adminCenterBaseUrl), getProductUrl(licencePlanId, true, config.adminCenterBaseUrl), dataFunction);
    };
    /**
     * Close dialog
     */
    const closeDialog = () => {
        if (prioritizeInAppPurchase(from) && state.isAppPurchaseOpened) {
            setState((prev) => ({ ...prev, isAppPurchaseOpened: false }));
            dispatch(getPremium({ tid: tenantId, userId }));
            dispatch(openModal(undefined));
        }
        else if (state.showPremiumActivatedContent)
            window.location.reload();
        else if (state.appSourceOpened) {
            setState((prev) => ({ ...prev, appSourceOpened: false }));
            dispatch(getPremium({ tid: tenantId, userId }));
        }
        else
            dispatch(openModal(undefined));
    };
    /**
     * Send an access request. No admin to pick: Admin Center notifies every administrator of the tenant.
     * A refused request (network, or 409 when one is already pending) gives the button back, it does not
     * spin forever.
     */
    const sendAccessRequest = async () => {
        setRequestAccessFailed(false);
        setState((prev) => ({ ...prev, sendingAccessRequest: true }));
        try {
            await createAccessRequest(user, props.appId, state.requestAccessMessage, locale, config.adminCenterBaseUrl);
        }
        catch {
            setState((prev) => ({ ...prev, sendingAccessRequest: false }));
            setRequestAccessFailed(true);
            return;
        }
        setState((prev) => ({ ...prev, sendingAccessRequest: false, showRequestAccessDialog: false, requestAccessMessage: "", isRequestSent: true }));
    };
    const openRequestAccessDialog = () => setState((prev) => ({ ...prev, showRequestAccessDialog: true }));
    const closeRequestAccessDialog = () => {
        if (state.sendingAccessRequest)
            return;
        setRequestAccessFailed(false);
        setState((prev) => ({ ...prev, showRequestAccessDialog: false }));
    };
    const updateRequestAccessMessage = (message) => setState((prev) => ({ ...prev, requestAccessMessage: message }));
    return {
        state,
        closeDialog,
        sendAccessRequest,
        requestAccessFailed,
        openRequestAccessDialog,
        closeRequestAccessDialog,
        updateRequestAccessMessage,
        assignLicences,
        showPaymentPage,
        licencePlanId,
        setState,
        user,
        setLicencePlanId,
        appId: props.appId
    };
};
